import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../ui/Card";
import InputField from "../ui/InputField";
import Button from "../ui/Button";
import Toast from "../ui/Toast";
import "../../styles/login.css";

const CustomLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [loading, setLoading] = useState(false);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const showToast = (message, type) => {
    setToast({ message, type, show: true });
  };

  // Auto-login if token exists
  useEffect(() => {
    const token = localStorage.getItem("islogin");
    if (token) {
      const loginType = localStorage.getItem("logintype");
      const route =
        loginType === "Admin"
          ? "/admin"
          : loginType === "Assistant"
            ? "/assistant"
            : "/doctor";
      navigate(route);
    }
  }, [navigate]);

  // Load remembered email
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRemember(true);
    }
  }, []);

  const showError = (msg) => {
    showToast(msg, "danger");
  };

  const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  if (!email.trim() || !password.trim()) {
    showToast("Invalid Credentials", "danger");
    setLoading(false);
    return;
  }

  try {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ADMIN_LOGIN}`;

    const response = await fetch(path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    const result = await response.json();

    // FIRST check login success
    if (result?.status === true) {
      const userData = result?.data?.Data || result?.data || {};

      const userRole  = userData.role || userData.Role || "";
      const userName  = userData.name || userData.Name || "User";
      const userEmail = userData.email || userData.Email || "";

      localStorage.setItem("adminId", userData.admin_id || "");

      if (userRole === "Assistant") {
        localStorage.setItem("assistant_id", userData.assistant_id || "");
        localStorage.setItem("assId", userData.assistant_id || "");
      }

      if (userRole === "Doctor") {
        localStorage.setItem("drId", userData.doctor_id || "");
      }

      localStorage.setItem("adminuser", JSON.stringify({
        name: userName,
        email: userEmail,
      }));

      localStorage.setItem("islogin", true);
      localStorage.setItem("logintype", userRole);

      if (remember) {
        localStorage.setItem("rememberEmail", email);
      } else {
        localStorage.removeItem("rememberEmail");
      }

      showToast("Login Successful", "success");

      setTimeout(() => {
        navigate(
          userRole === "Admin"
            ? "/admin"
            : userRole === "Assistant"
            ? "/assistant"
            : "/doctor"
        );
      }, 1000);

    } else {
      showError(result.message || "Login failed");
    }

  } catch (error) {
    showError("Server error. Please try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="login-container">
      <div className="circle one"></div>
      <div className="circle two"></div>

      <Card>
        <h2 className="title">OM Dental Clinic</h2>
        <p className="subtitle">Smile Brighter Every Day 😊</p>

        <form onSubmit={handleLogin}>
          <InputField
            type="email"
            label="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            disabled={loading}
          />

          <InputField
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            disabled={loading}
          />

          <div className="remember-me">
            <input
              type="checkbox"
              id="remember-checkbox"
              checked={remember}
              onChange={() => setRemember(!remember)}
              disabled={loading}
            />
            <label htmlFor="remember-checkbox">Remember Me</label>
          </div>

          <Button
            title={loading ? "Logging in..." : "Login"}
            disabled={loading}
          />

          <p className="extra">
            Forgot password? <span>Click here</span>
          </p>
        </form>
        <Toast
          show={toast.show}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, show: false })}
        />
      </Card>
    </div>
  );
};

export default CustomLogin;
